export function encodeImageRequest(request, referenceFile) {
  if (!referenceFile) return {headers:{'Content-Type':'application/json'},body:JSON.stringify(request)};
  const body = new FormData();
  // Blob prevents HTML multipart serialization from normalizing prompt newlines.
  body.set('request',new Blob([JSON.stringify(request)],{type:'application/json'}),'request.json');
  body.set('image',referenceFile);
  return {body};
}
export async function generateImage(request, referenceFile, signal) {
  const response = await fetch('/api/generate-image',{method:'POST',...encodeImageRequest(request,referenceFile),signal});
  const data = await response.json().catch(() => null);
  if (!response.ok) throw new Error(data?.error || `Image request failed (${response.status}). Do not retry automatically; the previous request may have incurred a charge.`);
  if (!data?.results?.length) throw new Error('No saved image was returned.');
  return {...data,results:data.results.map(result => {
    if (result.url) return {...result,resultUrl:result.url};
    const bytes=Uint8Array.from(atob(result.b64_json),c=>c.charCodeAt(0));
    return {...result,b64_json:undefined,resultUrl:URL.createObjectURL(new Blob([bytes],{type:result.mimeType || 'image/png'}))};
  })};
}
